import moment from 'moment'

export function formatDateTime(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY年M月D日 H時mm分')
}

export function formatDate(dateToFormat: string): string {
    const postDate = new Date(dateToFormat)
    return moment(postDate.toISOString()).format('YYYY年M月D日')
}

export function formatDateSlashSeparator(dateToFormat: string): string {
    const postDate = new Date(dateToFormat)
    return moment(postDate.toISOString()).format('YYYY/MM/DD')
}

export function formatDateTimeSlashSeparator(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY/MM/DD HH:mm')
}

export function formatDateZeroPadding(dateToFormat: string): string {
    const postDate = new Date(dateToFormat)
    return moment(postDate.toISOString()).format('YYYY年MM月DD日')
}

export function formatDateTimeZeroPadding(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY年MM月DD日 HH時mm分')
}

export function formatDateWithDayOfTheWeek(dateToFormat: string): string {
    const postDate = new Date(dateToFormat)
    return moment(postDate.toISOString()).format('YYYY年M月D日(ddd)')
}

export function formatDateWithDayOfTheWeekFromDate(date: Date): string {
    return moment(date.toISOString()).format('YYYY年M月D日(ddd)')
}

export function formatDatetimeWithDayOfTheWeekFromDate(date: Date): string {
    return moment(date.toISOString()).format('YYYY年M月D日(ddd) H:mm')
}

export function formatDateTimeWithoutSeconds(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY-MM-DD HH:mm')
}

export function formatDateTimeForDatePicker(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY-MM-DDTHH:mm')
}

export function formatDateTimeForUpdateDate(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY-MM-DD HH:mm:ss')
}

export function formatDateTimeForUpdateDateFromDate(date: Date): string {
    return moment(date.toISOString()).format('YYYY-MM-DD HH:mm:ss')
}

export function formatForDateInput(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return formatForDateInputFromDate(postDate)
}

export function formatForDateInputFromDate(date: Date): string {
    return moment(date.toISOString()).format('YYYY-MM-DD')
}

export function formatForYearMonthInputFromDate(date: Date): string {
    return moment(date.toISOString()).format('YYYY-MM')
}

export function formatDatetimeSimple(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('M/D H:mm')
}

export function formatDatetimeSlashSeparator(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY/M/D H:mm')
}

export function formatDatetimeSlashSeparatorFromDate(date: Date): string {
    return moment(date.toISOString()).format('YYYY/M/D H:mm')
}

export function formatForDateInputDotSeparator(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('YYYY.MM.DD')
}

export function formatForTimeInput(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('HH:mm')
}

export function formatForHourInput(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('H')
}

export function formatForMinutesInput(stringWithoutTimeZone: string): string {
    const postDate = new Date(stringWithoutTimeZone)
    return moment(postDate.toISOString()).format('m')
}

export function joinDateAndTime(date: string, time: string): string {
    return `${date}T${time}`
}

export interface DateTimeStrings {
    date: string
    time: string
}

export function splitDateTimeString(dateTime: string): DateTimeStrings {
    const [date, time] = dateTime.split('T')
    return {
        date: date,
        time: time,
    }
}
